import { BiSkipNext, BiSkipPrevious } from "react-icons/bi";
import { IoPause, IoPlay } from "react-icons/io5";
import { useAudio } from "../context/audio-context";
import * as S from "./audio-controls.style";
import { IoIosRefresh } from "react-icons/io";
import React from "react";

export const AudioControls = () => {
  const { handlePlayPause, isPlaying, handleSkip, handleNextPrevious } =
    useAudio();

  return (
    <S.Controls>
      <S.ControlButton
        bgcolor="transparent"
        onClick={() => handleNextPrevious("previous")}
      >
        <BiSkipPrevious size={25} />
      </S.ControlButton>

      <S.ControllButtonContainer onClick={() => handleSkip(-15)}>
        <S.ControlButtonTimeSkip>15</S.ControlButtonTimeSkip>
        <S.ControlButtonBack bgcolor="transparent">
          <IoIosRefresh size={20} />
        </S.ControlButtonBack>
      </S.ControllButtonContainer>

      <S.ControlButtonPlay onClick={() => handlePlayPause()}>
        {isPlaying ? <IoPause size={20} /> : <IoPlay size={20} />}
      </S.ControlButtonPlay>

      <S.ControllButtonContainer
        position="right"
        onClick={() => handleSkip(15)}
      >
        <S.ControlButtonSkip bgcolor="transparent">
          <IoIosRefresh size={20} />
        </S.ControlButtonSkip>
        <S.ControlButtonTimeSkip>15</S.ControlButtonTimeSkip>
      </S.ControllButtonContainer>

      <S.ControlButton
        bgcolor="transparent"
        onClick={() => handleNextPrevious("next")}
      >
        <BiSkipNext size={25} />
      </S.ControlButton>
    </S.Controls>
  );
};
